// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3305":"466a2364","5590":"3672203e"}[chunkId] + ".chunk.css";
};